module.exports = __webpack_public_path__ + "static/media/pattern-hero.bedbbd26.png";